var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCellOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 29.763,
    viewBox: "0 0 21 29.763",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5f5f5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1026",
    "data-name": "Group 1026",
    transform: "translate(-267 -6.237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_817",
    "data-name": "Rectangle 817",
    transform: "translate(267 15)",
    fill: "#f5f5f5",
    stroke: "#061133",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 19.5,
    height: 19.5,
    rx: 3.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_818",
    "data-name": "Rectangle 818",
    width: 10,
    height: 4,
    transform: "translate(273 14)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "right-arrow_2_",
    "data-name": "right-arrow (2)",
    transform: "translate(190.65 17.251) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M16.475,61.746a.344.344,0,0,0-.075-.112l-4.125-4.125a.344.344,0,0,0-.486.486l3.539,3.539H8.594A7.916,7.916,0,0,1,.688,53.627a.344.344,0,1,0-.688,0,8.6,8.6,0,0,0,8.594,8.594h6.733l-3.538,3.538a.344.344,0,0,0,.478.495l.008-.008L16.4,62.12A.341.341,0,0,0,16.475,61.746Z",
    transform: "translate(-6 26)",
    fill: "#061133",
    stroke: "#061133",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCellOut);
export default __webpack_public_path__ + "static/media/Icon-cell-out.357091c3bd19d15fead573215bde79b7.svg";
export { ForwardRef as ReactComponent };